module.exports = __webpack_public_path__ + "img/1.16961a4a.jpg";